module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppModal', {
    attrs: {
      "show": _vm.openFromOtherComponent
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_vm._v(">\n  "), _c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.edit_name')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.editCalendarEditName.calendar_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calName),
      expression: "calName"
    }],
    class: {
      'missing-input': !_vm.validateInput()
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.calName)
    },
    on: {
      "keyup": _vm.validateInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.calName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-end align-center pad-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.validateInput()) ? _c('p', {
    staticClass: "warning-text marg-10-right"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.warning_text')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.validateInput()) ? _c('button', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submitNewName
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.update_name')) + "\n    ")]) : _c('button', {
    staticClass: "submit-btn--disabled"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.editCalendarEditName.update_name')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8402db10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditCalendars/EditCalendarEditName.vue
// module id = 2048
// module chunks = 1